export default function getSelection(activeSelection, {districts, schools, educators, classes}) {
// Might have issues with this function when if any of the collections are blank. Watch for this issue.
  if (districts && schools && educators && classes) {
    if (districts[activeSelection]) {
      return {
        district: activeSelection,
        school: '',
        teacher: '',
        class: '',
      }
    } else if (schools[activeSelection]) {
      return {
        district: schools[activeSelection].district,
        school: activeSelection,
        teacher: '',
        class: '', 
      }   
    } else if (educators[activeSelection]) {
      if (educators[activeSelection].role === 'Teacher') {
        return {
          district: educators[activeSelection].schoolDistrict,
          school: educators[activeSelection].school,
          teacher: activeSelection,
          class: '',
        }
      } else {
        // Eventually change this. Just for testing. Should not be able to select non-Teachers in ManageEducators
        return {
          district: educators[activeSelection].schoolDistrict,
          school: educators[activeSelection].school ? educators[activeSelection].school : '',
          teacher: '',
          class: '',
        }
      }
    } else if (classes[activeSelection]) {
      return {
        district: classes[activeSelection].district,
        school: classes[activeSelection].school,
        teacher: classes[activeSelection].teacher,
        class: activeSelection,
      }
    } else {
      return {
        district: '',
        school: '',
        teacher: '',
        class: '',
      }
    }
  } else {
    return {
      district: '',
      school: '',
      teacher: '',
      class: '',
    }
  }
}


// WEBPACK FOOTER //
// ./src/helpers/users/getSelection.js